import { render, staticRenderFns } from "./MarketCoin.vue?vue&type=template&id=4001c25c&scoped=true"
import script from "./MarketCoin.vue?vue&type=script&lang=js"
export * from "./MarketCoin.vue?vue&type=script&lang=js"
import style0 from "./MarketCoin.vue?vue&type=style&index=0&id=4001c25c&prod&lang=scss&scoped=true"
import style1 from "./MarketCoin.vue?vue&type=style&index=1&id=4001c25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4001c25c",
  null
  
)

export default component.exports